import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { DateFunctions } from "common/datefunctions";

const SchemeTester = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);
  const modelInfo = selectedRow.modelInfo
    ? JSON.parse(selectedRow.modelInfo)
    : {};
  const modelData = selectedRow.modelData
    ? JSON.parse(selectedRow.modelData)
    : {};
  const modelResult = selectedRow.modelResult
    ? JSON.parse(selectedRow.modelResult)
    : {};

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "testedOn",
      name: LABELS.TESTED_ON,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "info",
      name: LABELS.MODEL_INFO,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "data",
      name: LABELS.MODEL_DATA,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "result",
      name: LABELS.MODEL_RESULT,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  // useEffect(() => {
  // }, []);

  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const reloadGrid = () => {
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setGridLoading(false);
    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setLoading(true);
    setRows(null);
    setGridLoading(false);

    MASTER_APIs.getSchemeTesters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          list[i]["info"] = JSON.parse(list[i].modelInfo).modelInfo;
          list[i]["data"] = JSON.parse(list[i].modelData).modelData;
          list[i]["result"] = JSON.parse(list[i].modelResult).modelResult;
        }
        setRows(list);
        setLoading(false);
      }
    });
  };
  const manageRecord = () => {
    const testedOn = (
      document.getElementById("testedOn") as HTMLInputElement
    ).value.trim();
    const modelInfo = (
      document.getElementById("modelInfo") as HTMLInputElement
    ).value.trim();
    const modelData = (
      document.getElementById("modelData") as HTMLInputElement
    ).value.trim();
    const modelResult = (
      document.getElementById("modelResult") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    // Validations;
    let errors = [];

    if (testedOn === "") {
      errors.push({
        id: "detail",
        msg:
          "<span class='bold'>" +
          LABELS.DETAILS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (modelInfo === "") {
      errors.push({
        id: "modelInfo",
        msg:
          "<span class='bold'>" +
          LABELS.MODEL_INFO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (modelData === "") {
      errors.push({
        id: "modelData",
        msg:
          "<span class='bold'>" +
          LABELS.MODEL_DATA +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (modelResult === "") {
      errors.push({
        id: "modelResult",
        msg:
          "<span class='bold'>" +
          LABELS.MODEL_RESULT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      testedOn,
      modelInfo: { modelInfo: modelInfo },
      modelData: { modelData: modelData },
      modelResult: { modelResult: modelResult },
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageSchemeTester(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("Page: Country:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SCHEME_TESTER}</li>
        </ul>
        <h4>{TITLES.SCHEME_TESTER}</h4>
        <p>{SUB_TITLES.SCHEME_TESTER}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"schemeTester"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.SCHEME_TESTER}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.SCHEME_TESTER + ": " + modelInfo.modelInfo
              : "Add " + TITLES.SCHEME_TESTER
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup required ">
              <TxtRow
                id={"testedOn"}
                label={LABELS.TESTED_ON}
                defaultValue={
                  selectedRow.id
                    ? selectedRow.testedOn
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                type={"date"}
                required={true}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup required ">
              <TxtRow
                id={"modelInfo"}
                label={LABELS.MODEL_INFO}
                defaultValue={modelInfo.modelInfo}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup required ">
              <TxtRow
                id={"modelData"}
                label={LABELS.MODEL_DATA}
                defaultValue={modelData.modelData}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup required ">
              <TxtRow
                id={"modelResult"}
                label={LABELS.MODEL_RESULT}
                defaultValue={modelResult.modelResult}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup required">
              <label>
                {LABELS.ACTIVE_STATUS}
                <span>*</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: isSubmit,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: isSubmit,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            {/* mandatoryResults */}
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(SchemeTester);
